import React from 'react';
import {PlanGetSchema} from '../../../../api/DBSchema/Plan';
import BaseQos from '../../AbstractObjects/GatewayPlan/InnerPages/BaseQos';

const pageSchema = PlanGetSchema.pages.qos;
const pageId = pageSchema.pageId;

function PlanQos({
    planObject,
    setPlanData
}) {

    let pageData = planObject[pageId];
    
    return (
        <BaseQos
            pageData={pageData}
            setObjectData={setPlanData}
        />
    );
}

export default PlanQos;